// extracted by mini-css-extract-plugin
module.exports = {"container":"Competition_container__dv6DJ","title":"Competition_title__2t2Ch","dsc":"Competition_dsc__rL-TB","links":"Competition_links__nQ4jZ","footer":"Competition_footer__2dv6b"};